import {UserIdentification, UserTrackingService} from './../domain/user-tacking.service';
import {Injectable} from '@angular/core';
import {AdobeTrackingServiceCapacitorPlugin} from "@app/core/tracking/infrastructure/adobe-tracking-service-capacitor-plugin";

@Injectable()
export class NativeUserTrackingService implements UserTrackingService {

    private previousIdentificationCode: string | undefined;

    notifyUserHasChanged(identification?: UserIdentification) {
        const newCode = `${identification?.deliveryPointCode}?${identification?.email.toLowerCase()}`;
        const code = identification ? newCode :  'CLI000?invitado@europastry.com';
        if (this.previousIdentificationCode === code) {
            return;
        }
        AdobeTrackingServiceCapacitorPlugin.notifyUserHasChanged({code: code});
        this.previousIdentificationCode = code;
    }

    registerPushService() {
        AdobeTrackingServiceCapacitorPlugin.registerPushService();
    }
}
